import { render, staticRenderFns } from "./discountTable.vue?vue&type=template&id=6cae49df&scoped=true"
import script from "./discountTable.vue?vue&type=script&lang=js"
export * from "./discountTable.vue?vue&type=script&lang=js"
import style0 from "./discountTable.vue?vue&type=style&index=0&id=6cae49df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cae49df",
  null
  
)

export default component.exports